import React from 'react'
import FormRichTextLanguage from 'components/forms/FormRichTextLanguage'

const TextEditorContent = FormRichTextLanguage

TextEditorContent.propTypes = {}
TextEditorContent.defaultProps = {}

export default TextEditorContent



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/elementForms/textEditor/TextEditorContent.js